import classNames from 'classnames';
import { SVGPropsIcon } from 'src/types';

type PropsArrow = {
  className?: string;
  openList?: () => void;
  style?: React.CSSProperties;
  fill?: string;
};

export const Arrow = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke={props.fill}
      onClick={props.onClick}
      className={props.className}
      style={props.style}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
    </svg>
  );
};

export const SidebarArrow = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 12.0005H19"
        stroke="var(--arrow_sidebar)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 5.00049L19 12.0005L12 19.0005"
        stroke="var(--arrow_sidebar)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LoyaltyArrow = (props: SVGPropsIcon) => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M25 0C11.2146 0 0 11.2146 0 25C0 38.7854 11.2146 50 25 50C38.7854 50 50 38.7854 50 25C50 11.2146 38.7854 0 25 0ZM32.7229 26.4729L22.3063 36.8896C21.9 37.2958 21.3667 37.5 20.8333 37.5C20.3 37.5 19.7666 37.2958 19.3604 36.8896C18.5458 36.075 18.5458 34.7583 19.3604 33.9438L28.3042 25L19.3605 16.0562C18.5459 15.2417 18.5459 13.925 19.3605 13.1104C20.175 12.2959 21.4917 12.2959 22.3063 13.1104L32.7229 23.5271C33.5375 24.3417 33.5375 25.6583 32.7229 26.4729Z"
        fill="#FFAD0E"
      />
      <path
        d="M32.7229 26.4729L22.3063 36.8896C21.9 37.2958 21.3667 37.5 20.8333 37.5C20.3 37.5 19.7666 37.2958 19.3604 36.8896C18.5458 36.075 18.5458 34.7583 19.3604 33.9438L28.3042 25L19.3605 16.0562C18.5459 15.2417 18.5459 13.925 19.3605 13.1104C20.175 12.2959 21.4917 12.2959 22.3063 13.1104L32.7229 23.5271C33.5375 24.3417 33.5375 25.6583 32.7229 26.4729Z"
        fill="#2B1134"
      />
      <path
        d="M33.0765 26.8265L33.0765 26.8265C34.0863 25.8166 34.0863 24.1834 33.0765 23.1736L22.6598 12.7569C21.65 11.7471 20.0167 11.7471 19.0069 12.7569C17.9971 13.7667 17.9971 15.4 19.0069 16.4098L27.5971 25L19.0068 33.5902C17.997 34.6 17.997 36.2333 19.0068 37.2431C19.5104 37.7467 20.1725 38 20.8333 38C21.4942 38 22.1563 37.7467 22.6598 37.2431L33.0765 26.8265ZM28.6578 25.3536L29.0113 25L28.6578 24.6464L19.714 15.7027C19.0947 15.0834 19.0947 14.0833 19.714 13.464C20.3333 12.8447 21.3334 12.8447 21.9527 13.464L32.3694 23.8807C32.9887 24.5 32.9887 25.5 32.3694 26.1194L21.9527 36.536C21.6438 36.8449 21.2392 37 20.8333 37C20.4275 37 20.0228 36.8449 19.7139 36.536C19.0946 35.9167 19.0946 34.9166 19.7139 34.2973L28.6578 25.3536ZM0.5 25C0.5 11.4907 11.4907 0.5 25 0.5C38.5093 0.5 49.5 11.4907 49.5 25C49.5 38.5093 38.5093 49.5 25 49.5C11.4907 49.5 0.5 38.5093 0.5 25Z"
        stroke="#412949"
      />
    </svg>
  );
};

export const ArrowSingleGame = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={props.onClick}
      className={classNames(props.className)}
      style={props.style}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3447 6.4541C11.0335 6.7653 10.529 6.7653 10.2178 6.4541L6 2.23633L1.78223 6.4541C1.47103 6.7653 0.966473 6.7653 0.655274 6.4541C0.344075 6.1429 0.344075 5.63835 0.655275 5.32715L5.43652 0.545899C5.74772 0.2347 6.25228 0.2347 6.56348 0.545899L11.3447 5.32715C11.6559 5.63835 11.6559 6.1429 11.3447 6.4541Z"
        fill="var(--sgp_header_arrow)"
      />
    </svg>
  );
};

export const ArrowsShop = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g id="exchange 1" clipPath="url(#clip0_14092_80235)">
        <path
          id="Vector"
          d="M25.0879 18.9275V21.3408C25.0879 22.1073 25.241 22.7504 25.5431 23.2513C25.9599 23.9427 26.644 24.339 27.4207 24.339C28.1817 24.339 28.9379 23.9684 29.6681 23.2382L37.6391 15.2672C39.3892 13.5171 39.3892 10.6694 37.6391 8.91931L29.6681 0.948364C28.9379 0.217773 28.1817 -0.152466 27.4207 -0.152466C26.2594 -0.152466 25.0879 0.77478 25.0879 2.8457V5.03748C13.7713 5.70581 4.40288 14.3905 3.01054 25.761C2.93254 26.396 3.29362 27.0039 3.88872 27.2394C4.05717 27.306 4.23259 27.3383 4.4058 27.3383C4.84453 27.3383 5.27006 27.1328 5.54106 26.7626C9.27568 21.6598 15.272 18.6133 21.5811 18.6133C22.75 18.6133 23.9256 18.7188 25.0879 18.9275Z"
          fill="white"
          fillOpacity="0.5"
        />
        <path
          id="Vector_2"
          d="M44.0861 20.4553C43.491 20.2194 42.812 20.4157 42.4337 20.9324C38.6995 26.0348 32.7031 29.0814 26.3941 29.0814C25.2251 29.0814 24.0496 28.9759 22.8872 28.7671V26.3538C22.8872 24.2829 21.7153 23.3556 20.5545 23.3556C19.7935 23.3556 19.0372 23.7263 18.3067 24.4568L10.3357 32.4274C8.58595 34.1775 8.58595 37.0252 10.3361 38.7757L18.3067 46.7463C19.0372 47.4769 19.7935 47.8471 20.5545 47.8471C21.7153 47.8471 22.8872 46.9199 22.8872 44.8489V42.6572C34.2042 41.9888 43.5723 33.3041 44.9646 21.934C45.0426 21.2986 44.6815 20.6907 44.0861 20.4553Z"
          fill="white"
          fillOpacity="0.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_14092_80235">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DropdownArrow = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.71209 6.53435C4.0782 6.16824 4.6718 6.16824 5.03791 6.53435L10 11.4964L14.9621 6.53436C15.3282 6.16824 15.9218 6.16824 16.2879 6.53436C16.654 6.90047 16.654 7.49406 16.2879 7.86018L10.6629 13.4852C10.2968 13.8513 9.7032 13.8513 9.33709 13.4852L3.71209 7.86018C3.34597 7.49406 3.34597 6.90047 3.71209 6.53435Z"
        fill="white"
      />
    </svg>
  );
};

export const ArrowSeo = ({ className, openList, style, fill }: PropsArrow) => {
  return (
    <svg
      stroke="currentColor"
      onClick={openList}
      className={classNames(className)}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="white">
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M12.0002 16.4999C11.8686 16.5007 11.7381 16.4755 11.6163 16.4257C11.4944 16.3759 11.3836 16.3026 11.2902 16.2099L5.29019 10.2099C5.10188 10.0216 4.99609 9.76624 4.99609 9.49994C4.99609 9.23364 5.10188 8.97825 5.29019 8.78994C5.47849 8.60164 5.73388 8.49585 6.00019 8.49585C6.26649 8.49585 6.52188 8.60164 6.71019 8.78994L12.0002 14.0899L17.2902 8.79994C17.4815 8.63612 17.7276 8.55051 17.9792 8.56023C18.2309 8.56995 18.4697 8.67428 18.6477 8.85238C18.8258 9.03047 18.9302 9.26921 18.9399 9.52089C18.9496 9.77256 18.864 10.0186 18.7002 10.2099L12.7002 16.2099C12.5139 16.3947 12.2625 16.4988 12.0002 16.4999Z"
        fill={classNames(fill ? fill : 'var(--i_arrow)')}
      />
    </svg>
  );
};

export const ArrowLeft = (props: SVGPropsIcon) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M20 -1.74846e-07C22.2091 -7.8281e-08 24 1.79086 24 4L24 20C24 22.2091 22.2091 24 20 24L4 24C1.79086 24 -9.70792e-07 22.2091 -8.74228e-07 20L-1.74846e-07 4C-7.8281e-08 1.79086 1.79086 -9.70792e-07 4 -8.74228e-07L20 -1.74846e-07Z"
      fill="none"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.1705 4.4545C16.6098 4.89384 16.6098 5.60616 16.1705 6.0455L10.216 12L16.1705 17.9545C16.6098 18.3938 16.6098 19.1062 16.1705 19.5455C15.7312 19.9848 15.0188 19.9848 14.5795 19.5455L7.8295 12.7955C7.39016 12.3562 7.39017 11.6438 7.8295 11.2045L14.5795 4.4545C15.0188 4.01516 15.7312 4.01517 16.1705 4.4545Z"
      fill="white"
    />
  </svg>
);

export const ArrowRight = (props: SVGPropsIcon) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M4 24C1.79086 24 2.13558e-08 22.2091 4.76995e-08 20L2.38498e-07 4C2.64841e-07 1.79086 1.79086 2.13558e-08 4 4.76995e-08L20 2.38498e-07C22.2091 2.64841e-07 24 1.79086 24 4L24 20C24 22.2091 22.2091 24 20 24L4 24Z"
      fill="none"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.8295 19.5455C7.39017 19.1062 7.39017 18.3938 7.8295 17.9545L13.784 12L7.82951 6.04549C7.39017 5.60616 7.39017 4.89384 7.82951 4.45451C8.26884 4.01517 8.98116 4.01517 9.4205 4.45451L16.1705 11.2045C16.6098 11.6438 16.6098 12.3562 16.1705 12.7955L9.4205 19.5455C8.98116 19.9848 8.26884 19.9848 7.8295 19.5455Z"
      fill="white"
    />
  </svg>
);
